// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".height-auto{height:auto!important;overflow:initial!important;width:100%}.v-align-center.v-icon{vertical-align:bottom}.select-state{position:relative;top:12px}.table_trasparent .theme--light.v-data-table{background:transparent;color:#fff}", ""]);
// Exports
module.exports = exports;
